import { render } from "./AdminSkinStory.vue?vue&type=template&id=5e4a338a"
import script from "./AdminSkinStory.vue?vue&type=script&lang=js"
export * from "./AdminSkinStory.vue?vue&type=script&lang=js"

import exportComponent from "/home/mihai/repos/skinscience/skinatlas/src/clientapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__